module.exports = __webpack_public_path__ + "static/media/calendar-cross-fill.8b66ca88.svg";